import { AchievementDefFilter } from "./achievment-def.filter";



export class BadgeDefFilter extends AchievementDefFilter {
    
}